import script from "./NotificationDetailsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationDetailsDialog.vue?vue&type=script&setup=true&lang=js"

import "./NotificationDetailsDialog.vue?vue&type=style&index=0&id=5e6a2335&lang=css"

const __exports__ = script;

export default __exports__